import { Auth0Provider } from '@auth0/auth0-react';
import { AppState } from '@auth0/auth0-react/src/auth0-provider.tsx';
import { ReactElement } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export const WrapAuthProvider = (): ReactElement | null => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = `${window.location.protocol}//${window.location.host}`;

  const onRedirectCallback = (appState: AppState | undefined) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: 'https://bidding.jplus.io',
        scope: 'openid profile email read:users',
        redirect_uri: redirectUri,
        connection: 'google-oauth2',
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
    >
      <Outlet />
    </Auth0Provider>
  );
};
